module.exports = __webpack_public_path__ + "media/images/lb/559-a39c70dc345bfaea271e2e1ff275c2d6.svg";